// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}._154i1ssb{top:50%}\n._1bsb7vkz{width:1pc}\n._1ltv1ssb{left:50%}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._4t3i7vkz{height:1pc}\n._kqswstnw{position:absolute}\n._t9ec1ooe{transform:translate(-50%,-50%)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
